import ExpandCollapsedIcon from './ExpandCollapsedIcon.Component';
export const DsBreadcrumbsDefaultProps = {
    maxItems: 4,
    itemsAfterCollapse: 3,
    itemsBeforeCollapse: 1,
    slots: { CollapsedIcon: ExpandCollapsedIcon }
};
